// dialogo-mensaje.controller.js
"use strict";

class dialogoMensajeController {
  constructor($sce) {
    this.$sce = $sce;
    this.iconosValidos = ['ic-luz', 'face-ok', 'face-ko'];
  }

  $onInit() {
    if (!this.icono || this.iconosValidos.indexOf(this.icono) === -1) {
      this.icono = 'ic-luz';
    }
  }

  onCerrar(){
    this.close();
  }
}

dialogoMensajeController.$inject = ["$sce"];

export { dialogoMensajeController as DIALOGO_MENSAJE_CONTROLLER };
